import * as Types from '../../constants/actionTypes';

const initialState = {
  isUnauthorized: false
}
export default (state = initialState, action) => {
  //console.log(`state in auth is :`,state);
  switch (action.type) {

    case Types.SET_TOKEN:
      return {
        ...state,
        token: action.token,
        isUserAuthenticated: true
      }

    case Types.SET_MFA_SESSION:
      return {
        ...state,
        session: action.session,
        mfaType: action.mfaType,
        qrCode: action.qrCode
      }

    case Types.SET_REFRESH_TOKEN:
      return {
        ...state,
        refreshToken: action.refreshToken
      }

      case Types.AUTH_LOGIN_ERROR: {
        return {
          ...state,
          authLoginError: action.authLoginError,
          authErrorCode: action.authErrorCode,
        }
      }

      case Types.IS_USER_AUTHENTICATED: {
        delete state.refreshToken
      delete state.token
        return {
          ...state,
          isUserAuthenticated: action.isUserAuthenticated
        }
      }

      case Types.SET_UNAUTHORIZED_ERROR: {
        return {
          ...state,
          isUnauthorized: action.payload,
        }
      }

      case Types.USER_LOGIN_DETAILS:
      return {
        ...state,
        loginData: action.data,
     }
     case Types.COGNITO_USER_DETAILS:
     return {
        ...state,
        cognitoUser: action.data.cognitoUser,
        username: action.data.username,
     }
    case Types.ON_LOGOUT:
      return {
        ...state,
        isUserAuthenticated: false
      }

    /* Forgot Password Reducers */
    case Types.ADMIN_FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        forgotPswdError: action.forgotPswdError
      }
    case Types.ADMIN_CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePWDError: action.changePWDError
      }

    case Types.INITIATE_SET_PASSWORD_SUCCESS:
      return {
        ...state,
        isSetPasswordEnabled: true
      }
    case Types.USER_ACTIVATION_INITIATE_RESEND_ACTIVATION:
      return {
        ...state,
        isResendActivationRequired: true,
        isSetPasswordEnabled: false
      }
    case Types.PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS:
      return {
        ...state,
        isResendActivationRequired: false,
        isResendActivationSuccess: true
      }
      case Types.PORTAL_USER_ACTIVATION_FAILED:
        return {
          ...state,
          userActivateErrorMessage: action.errorMessage
        }
      case Types.INITIATE_UNAUTHORIZED_ACCESS:
        return {
          ...state,
          notAllowedToEnter: true
        }
      case Types.PORTAL_USER_RESET_PASSWORD_FAILED: {
          return {
            ...state,
            userResetPasswordErrorMessage: action.errorMessage
          }
        }
      case Types.LIST_PORTAL_SAME_USER: {
          return {
            ...state,
            portalsSameUser: action.portalsSameUser,
          }
        }
    default:
      return state;
  }
};
